import axios from 'axios';

export const apiZipCode = axios.create({
    baseURL: 'https://viacep.com.br/ws/',
});

const zipCondEndpoints = {
    zipCodeSearch: async (zipCode) => {
        const { data } = await apiZipCode.get(`${zipCode}/json/`);
        return data;
    },
};

export default zipCondEndpoints;
